export default {
  title: 'Nova Atividade Dinâmica',
  title_edit: 'Editando Atividade Dinâmica',

  //sections ___________________________________
  generalSectionName: 'Nome*',
  generalSectionChecklist: 'Questionário*',
  generalSectionType: 'Tipo do destino',
  generalSectionLevel: 'Nível do destino',
  generalSectionPlace: 'Destino',
  generalSectionDescription: 'Descrição*',

  themeSectionTitle: 'Tema',
  themeLogo: 'Logo',
  themeColor: 'Cor',

  redirectionSection: 'Redirecionamento',
  redirectionLabel: 'Ao responder, redirecionar para execução',

  completionSection: 'Configurações de finalização',
  completionTitleMessage: 'Título da mensagem de conclusão',
  completionBodyMessage: 'Corpo da mensagem de conclusão'
}
